//Smartphoto
window.addEventListener('DOMContentLoaded',function(){
    new SmartPhoto(".js-smartPhoto");

    $('[data-toggle="tooltip"]').tooltip()
});

jQuery(document).ready(function ($) {
    $(".gridder").gridderExpander({
        scrollOffset: 60,
        showNav: true,
        animationEasing: "easeInOutExpo"
    });
});

$(document).ready(function(){

    var _container_width = $('.container').first().width();

    if (_container_width > 980) {
        var _cmove = (_container_width - 980) / 200;
        var _dmove  = Math.floor( _cmove);

        if ( $("#navbarDropdown-mehr").length > 0) {
            var dropdown = $("#navbarDropdown-mehr");
            var dropdownli = $(dropdown).parent(".nav-item");

            if ( $(dropdown).next("ul").length > 0) {
                var ul = $(dropdown).next("ul");
                var counter = 0;
                $(ul ).children().each(function(){
                    if (counter < _dmove)  {
                        $(this).addClass("nav-item");
                        $(this).children("a").removeClass("dropdown-item").addClass("nav-link");
                        if($(this).find("li").length > 0) {
                            $(this).addClass("dropdown");
                            $(this).addClass("show");
                            $(this).children("a").addClass("dropdown-toggle");
                            $(this).children("a").attr("data-toggle","dropdown");
                            $(this).children("a").attr("aria-haspopup","true");
                            $(this).children("a").attr("aria-expanded","false");
                            $(this).children("ul").attr("aria-labelledby","navbarDropdownMenuLink");
                        }
                        if ($(this).hasClass("active")) {
                            $("#navbarDropdown-mehr").closest(".nav-item").removeClass("active");
                        }
                        $(dropdownli).before(this);
                    }

                    counter++;
                });
                if ($(dropdownli).find("li").length == 0 ){
                    $(dropdownli).remove();
                }
                if ($(dropdownli).find("li").length == 1 ){
                    var _li = $(dropdownli).find("li");
                    $(_li).addClass("nav-item");
                    $(_li).children("a").removeClass("dropdown-item").addClass("nav-link");
                    $(dropdownli).before(_li);
                    $(dropdownli).remove();
                }
                $(".dropdown").removeClass("show");
                $(".dropdown .dropdown-menu").removeClass("show");
                $( "a.dropdown-toggle" ).on( "click", function ( e ) {
                    if (!$(this).hasClass('dropdown-item')) {
                        var currentDropdown = $(this).closest(".dropdown");
                        var currentMenu = $(this).next(".dropdown-menu");
                        var isCurrentDropdownShown = currentDropdown.hasClass("show");
                        var isCurrentMenuShown = currentMenu.hasClass("show");
                        $(".dropdown").removeClass("show");
                        $(".dropdown-menu").removeClass("show");
                        if (isCurrentDropdownShown) {
                            currentDropdown.addClass("show");
                        }
                        if (isCurrentMenuShown) {
                            currentMenu.addClass("show");
                        }
                    }
                });

            }

        }
    }

    // calculate widths of nav-items
    $('#navbar ul.navbar-nav li.nav-item a.nav-link').each(function() {
        $(this).width(Math.ceil($(this).find('span:first').width()) + ($(this).hasClass('dropdown-toggle') ? 16 : 1));
    });
    // toggle filminfo and trailer on list view
    $('.container').on('click', '.collapser', function () {
        var initiator = $(this); // the button that's been clicked to initiate the toggle
        $(this).closest('.movie-list-view').find('.filmInfoText, .filmTrailer').collapse('hide');
        $(this).closest('.movie-list-view').find('.' + initiator.data('target')).on('show.bs.collapse', function () {
          initiator.addClass('active');
        }).on('hide.bs.collapse', function () {
          initiator.removeClass('active');
        }).collapse('toggle');
    });

    // Checkbox submit toggle
    var $submit = $("#newsletter-toggle").hide(),
        $cbs = $('input[name="check"]').click(function() {
            $submit.toggle( $cbs.is(":checked") );
        });
    });
    // Slider Progressbar

    $(document).ready(function(){
        var progressInterval = $('#carousel-indicator').data('interval') / 200;
        var percent = 0,
            $bar = $('.carousel-progress-bar'),
            $carousel = $('#carousel-indicator');
        $carousel.carousel({
            interval: false,
            pause: true
        }).on('slide.bs.carousel', function (){
            percent = 0;
    });

    function progressBarCarousel() {
        $bar.css({ width:percent+'%' });
        percent = percent + 0.5;
        if (percent >= 100) {
            percent = 0;
            $carousel.carousel('next');
        }
    }

    var barInterval = setInterval(progressBarCarousel, progressInterval);

    if (!(/Mobi/.test(navigator.userAgent))) {
        $carousel.hover(function(){
                clearInterval(barInterval);
            },
            function(){
                barInterval = setInterval(progressBarCarousel, progressInterval);
            }
        );
    }
});
